import "./PlanScreen.css"
import requests from "../api/requests"
import { useEffect, useState } from "react"
import { useSelector, useDispatch } from "react-redux"
import { getUser, logout } from "../app/features/userSlice"
import { useNavigate } from "react-router-dom"
import Button from "../components/Button"
import { useSnackbar } from "react-simple-snackbar"
import {
  DEFAULT_ERROR_MESSAGE,
  errorSnackBar,
} from "../components/snackBarOptions"
import { Skeleton } from "@mui/material"
import CosmosBackground from "../components/CosmosBackground"
import ArrowBackIcon from "@mui/icons-material/ArrowBack"
import CheckCircleIcon from "@mui/icons-material/CheckCircle"

function PlanScreen() {
  const user = useSelector(getUser)
  const dispatch = useDispatch()
  const [plans, setPlans] = useState([])
  const [isLoadingCheckout, setIsLoadingCheckout] = useState(false)
  const [selectedPlan, setSelectedPlan] = useState(null)
  const [openErrorSnackbar] = useSnackbar(errorSnackBar)
  const [loading, setLoading] = useState(false)

  const navigate = useNavigate()

  if (!user) {
    navigate("/")
  }

  useEffect(() => {
    const fecthPlans = async () => {
      setLoading(true)

      try {
        const subscriptions = await requests.getUserSubscription()
        if (
          subscriptions?.data?.status &&
          (subscriptions.data.status === "active" ||
            subscriptions.data.status === "trialing")
        ) {
          navigate("/")
          return
        }
      } catch (error) {
        console.log("not subscribed")
      }

      try {
        const respPlans = await requests.getPlans()
        setPlans(respPlans.data)
        if (respPlans.data.length > 0) {
          setSelectedPlan(respPlans.data[0])
        }
      } catch (error) {
        openErrorSnackbar(DEFAULT_ERROR_MESSAGE)
      }

      setLoading(false)
      return
    }

    fecthPlans()
  }, [])

  const loadCheckout = async (priceID) => {
    let resp = null

    try {
      resp = await requests.createCheckoutSession({
        priceID: priceID,
        cancelURL: window.location.origin,
        successURL: window.location.origin,
      })

      window.location.href = resp?.data?.url
    } catch (error) {
      if (error?.response?.data?.message === 'user_blacklisted') {
        navigate('/blocked')
      } else {
        openErrorSnackbar(DEFAULT_ERROR_MESSAGE)
      }
    }
  }

  const formatPrice = (amount) => {
    const formatter = new Intl.NumberFormat("pt-BR", {
      style: "currency",
      currency: "BRL",
    })

    return formatter.format(amount)
  }

  const formatInterval = (interval) => {
    if (interval === "month") interval = "mês"
    if (interval === "year") interval = "ano"
    return "por " + interval
  }

  const handlePlanClick = (plan) => {
    setSelectedPlan(plan)
  }

  const isPlanSelected = (plan) => {
    return selectedPlan?.id === plan.id
  }

  const handleCheckout = async () => {
    if (!selectedPlan) {
      openErrorSnackbar("Selecione um plano")
      return
    }

    setIsLoadingCheckout(true)
    await loadCheckout(selectedPlan.priceID)
    setIsLoadingCheckout(false)
  }

  const handleLogout = () => {
    dispatch(logout())
    navigate("/")
  }

  return (
    <div className="planScreen__wrapper">
      <CosmosBackground />
      <div className="planScreen">
        <img
          className="planScreen__logo"
          src={process.env.PUBLIC_URL + "/Primário_5.svg"}
          alt="Cosmo"
        />
        <button className="planScreen__back" onClick={handleLogout}>
          <ArrowBackIcon style={{ fontSize: "1rem" }} /> Sair
        </button>
        <h1>Estamos quase lá</h1>
        <h2 className="planScreen__subtitle">Confira os detalhes do seu plano</h2>
        {!loading ? (
          plans.map((plan) => (
            <div
              key={plan.id}
              onClick={() => handlePlanClick(plan)}
              className={`planScreen__plan${isPlanSelected(plan) ? " planScreen__plan--selected" : ""}`}
            >
              <div className="planScreen__plan__body">
                <h2>{plan.name}</h2>
                {plan.description && <p>{plan.description}</p>}
              </div>
              <div className="planScreen__plan__right">
                <div className="planScreen__plan__price">
                  <h3>{formatPrice(plan.amount)}</h3>
                  <p>{formatInterval(plan.recurrentInterval)}</p>
                </div>
                {isPlanSelected(plan) && (
                  <CheckCircleIcon className="planScreen__plan__check" />
                )}
              </div>
            </div>
          ))
        ) : (
          <div>
            <Skeleton height={80} animation="wave" sx={{ borderRadius: "12px" }} />
            <Skeleton height={80} animation="wave" sx={{ borderRadius: "12px" }} />
          </div>
        )}
        <Button
          onClick={handleCheckout}
          text="Ir para pagamento"
          isLoading={isLoadingCheckout}
        />
      </div>
    </div>
  )
}

export default PlanScreen
